import LocalStorage from "../services/LocalStorage.service";

import { type Variant, variants } from "./variants";

const MYMEX_DOMAIN = /mymex.cz/;
const AGROTRADE_DOMAIN = /agronutriconsult.sk/;

const isMyMexDomain = !!window.location?.hostname.match(MYMEX_DOMAIN);
const isAgrotradeDomain = !!window.location?.hostname.match(AGROTRADE_DOMAIN);

const savedTheme = LocalStorage.loadFromLocalStorage("theme") as Variant | null;

const resolveVariant = (): Variant => {
  if (isMyMexDomain) {
    return "mymex";
  }

  if (isAgrotradeDomain) {
    return "agrotrade";
  }

  return "cleverfarm";
};

export const getAppVariant = (): Variant => {
  let variant = savedTheme as Variant;

  if (!variants.includes(variant)) {
    variant = resolveVariant();
  }

  LocalStorage.saveToLocalStorage(variant, "theme");

  return variant;
};
